import { SVGProps } from "react";

const PngFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="32"
    fill="none"
    viewBox="0 0 34 32"
  >
    <path
      fill="#fff"
      d="M15.02.375h4.8c.775 0 1.52.3 2.08.837l5.137 4.931v9.253a3.004 3.004 0 0 1-3.004 3.004H15.02a3.004 3.004 0 0 1-3.004-3.004V3.38A3.004 3.004 0 0 1 15.02.375"
    ></path>
    <path
      stroke="#E6E6E6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.751"
      d="M27.037 6.143v9.253a3.004 3.004 0 0 1-3.004 3.004H15.02a3.004 3.004 0 0 1-3.004-3.004V3.38A3.004 3.004 0 0 1 15.02.375h4.8c.775 0 1.52.3 2.08.837zm0 0h-3.004a3.004 3.004 0 0 1-3.005-3.004V.736"
    ></path>
    <g filter="url(#a)">
      <rect
        width="15.772"
        height="6.253"
        x="9.012"
        y="8.633"
        fill="#5656CA"
        rx="1.878"
        shapeRendering="crispEdges"
      ></rect>
      <path
        fill="#fff"
        d="M10.849 13.758V9.66h1.46q.479 0 .792.174t.47.476q.156.3.156.676 0 .379-.158.68-.156.301-.472.476t-.79.175h-1.004v-.524h.948q.302 0 .49-.104a.65.65 0 0 0 .276-.289.94.94 0 0 0 .088-.414.9.9 0 0 0-.088-.412.63.63 0 0 0-.278-.282 1.04 1.04 0 0 0-.496-.102h-.776v3.567zm7.134-4.097v4.097h-.568l-2.082-3.005h-.038v3.005h-.618V9.66h.572l2.084 3.009h.038V9.66zm3.9 1.294a1.3 1.3 0 0 0-.156-.326 1 1 0 0 0-.536-.406 1.2 1.2 0 0 0-.374-.054q-.347 0-.624.178a1.2 1.2 0 0 0-.44.522q-.16.342-.16.838 0 .498.162.843.162.344.444.522.282.177.642.178.333 0 .582-.136a.95.95 0 0 0 .386-.384q.138-.25.138-.588l.16.03h-1.172v-.51h1.61v.465q0 .517-.22.897a1.5 1.5 0 0 1-.604.584q-.385.206-.88.206-.556 0-.976-.256a1.74 1.74 0 0 1-.652-.726q-.235-.473-.235-1.12 0-.49.136-.88t.383-.663q.247-.274.582-.418.336-.146.734-.146.331 0 .618.098.288.098.512.278a1.57 1.57 0 0 1 .574.974z"
      ></path>
    </g>
    <defs>
      <filter
        id="a"
        width="33.799"
        height="24.275"
        x="-0.001"
        y="7.131"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feMorphology
          in="SourceAlpha"
          radius="2.253"
          result="effect1_dropShadow_56554_62119"
        ></feMorphology>
        <feOffset dy="7.511"></feOffset>
        <feGaussianBlur stdDeviation="5.633"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00392157 0 0 0 0 0.0745098 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_56554_62119"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feMorphology
          in="SourceAlpha"
          radius="3.004"
          result="effect2_dropShadow_56554_62119"
        ></feMorphology>
        <feOffset dy="3.004"></feOffset>
        <feGaussianBlur stdDeviation="2.253"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.00784314 0 0 0 0 0.00392157 0 0 0 0 0.0745098 0 0 0 0.1 0"></feColorMatrix>
        <feBlend
          in2="effect1_dropShadow_56554_62119"
          result="effect2_dropShadow_56554_62119"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_56554_62119"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);
export default PngFile;
